import { db } from '.';

async function addFlowToDB(data) {
  const { id, ...docData } = data;
  const newFlowRef = db.collection('flows').doc(id);
  await newFlowRef.set(docData);
  return newFlowRef;
}

async function getFlowFromDB(id) {
  const ref = db.collection('flows').doc(id);
  const snapshot = await ref.get();
  return {
    id,
    ...snapshot.data()
  };
}

async function updateFlowInDB(data) {
  const { id, ...docData } = data;
  const ref = db.collection('flows').doc(id);
  await ref.update(docData);
}

async function publishFlow(id, mode) {
  const version = mode === 'admin' ? mode : '1.0';
  const ref = db.collection('flows').doc(id);
  const snap = await ref.get();
  const publishRef = ref.collection('published').doc(version);
  await publishRef.set(snap.data());
}

export default {
  add: addFlowToDB,
  get: getFlowFromDB,
  update: updateFlowInDB,
  publish: publishFlow
};
